import { css } from 'styled-components';

export const SkeletonStyle = css`
  background: linear-gradient(110deg, #f2f4f8 8%, #fff 18%, #f2f4f8 33%);
  background-size: 200% 100%;
  animation: 1.5s shine linear infinite;
  border-radius: 15px;
`;
